import { useSearchParameters } from '../../lib/hooks/useSearchParameters.js';
/**
 * Hook to get the index for coupon.
 *
 * @returns Index for coupon
 */
export function useCouponIndex() {
  const searchParams = useSearchParameters("coupon");
  const couponIndexQp = searchParams.coupon;
  return couponIndexQp ?? 0;
}